import {ChangeDetectorRef, Component, inject, OnInit} from '@angular/core';
import {SharedStateService} from "./core/services/shared-state.service";
import {CustomerService} from "./customer/services/customer.service";
import {HeaderComponent} from './core/components/header/header.component';
import {NavigationEnd, Router, RouterOutlet} from '@angular/router';
import {FooterComponent} from './core/components/footer/footer.component';
import {LoanService} from "./loan/services/loan.service";
import {GoogleAnalyticsService} from "./core/services/google-analytics-service";
import {MetaPixelService} from "./core/services/meta-pixel-service";

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  imports: [
    HeaderComponent,
    RouterOutlet,
    FooterComponent,
  ],
})
export class AppComponent implements OnInit {
  protected customerService = inject(CustomerService);
  protected loanService = inject(LoanService);
  protected sharedState = inject(SharedStateService);
  protected router = inject(Router);

  // Activating the instance executes the constructor tracking logic
  private googleAnalyticsService = inject(GoogleAnalyticsService);
  private metaPixelService = inject(MetaPixelService);

  title: string = 'minizaem';

  ngOnInit() {
    if (this.customerService.getJwt() && this.sharedState.isCustomerLogged()) {
      this.sharedState.customer.set(this.customerService.getFromStorage());
    } else {
      this.customerService.logout();
    }

    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd && this.sharedState.customer()) {
        this.loanService.showCurrentForCustomer().subscribe(
          {
            next: result => {
              this.sharedState.customerCurrentLoan.set(result);
            }
          }
        );
      }
    });
  }
}
